import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { Toaster } from "./components/ui/sonner";

// Pages
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import DecisionLibraryPage from "./pages/DecisionLibraryPage";
import DecisionDetailPage from "./pages/DecisionDetailPage";
import MeetingModePage from "./pages/MeetingModePage";
import UserManagementPage from "./pages/UserManagementPage";
import ImportExportPage from "./pages/ImportExportPage";

// Layout
import Layout from "./components/Layout";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public Route */}
          <Route path="/login" element={<LoginPage />} />
          
          {/* Protected Routes */}
          <Route element={<Layout />}>
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/decisions" element={<DecisionLibraryPage />} />
            <Route path="/decisions/:decisionId" element={<DecisionDetailPage />} />
            <Route path="/users" element={<UserManagementPage />} />
            <Route path="/import-export" element={<ImportExportPage />} />
          </Route>
          
          {/* Meeting Mode (Full Screen) */}
          <Route path="/meeting-mode" element={<MeetingModePage />} />
          
          {/* Default Redirect */}
          <Route path="/" element={<Navigate to="/decisions" replace />} />
          <Route path="*" element={<Navigate to="/decisions" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
